import { useTranslation } from "react-i18next";
import { divider, scoreWrapper } from "./matchScore.css";

interface MatchScoreProps {
  started?: boolean;
  isBye: boolean;
  inProgress: boolean;
  firstEntryPoints: number;
  secondEntryPoints: number;
}

const MatchScore = ({
  started,
  inProgress,
  isBye,
  firstEntryPoints,
  secondEntryPoints,
}: MatchScoreProps) => {
  const { t } = useTranslation("leaguesAndCups");
  const variant = inProgress ? "inProgress" : "default";

  return (
    <div className={scoreWrapper[variant]}>
      {isBye ? (
        <span>{t("notApplicableAbbreviation", "N/A")}</span>
      ) : started ? (
        <>
          <span>{firstEntryPoints}</span>
          <span className={divider} />
          <span>{secondEntryPoints}</span>
        </>
      ) : (
        <>
          <span>-</span>
          <span className={divider} />
          <span>-</span>
        </>
      )}
    </div>
  );
};

export default MatchScore;
